export const p2pRoutes = [
  {
    path: "/p2p",
    name: "P2P",
    component: () => import("@/views/P2P/MainList.vue"),
    meta: { topLevel: true, parent: "P2P", menu: true },
  },
  {
    path: "/p2p/page/:index",
    name: "P2PPage",
    component: () => import("@/views/P2P/MainList.vue"),
    meta: { topLevel: true, parent: "P2P", menu: true },
  },
  {
    path: "/p2p/history",
    name: "P2PHistory",
    component: () => import("@/views/P2P/History.vue"),
    meta: { parent: "P2PHistory" },
  },
  {
    path: "/p2p/history/page/:id",
    name: "P2PHistoryPage",
    component: () => import("@/views/P2P/Order.vue"),
    meta: { parent: "P2PHistory" },
  },
];
